import LifeBridge from '@tnlife/tn-bridge'

export class TnBridgeService {
  // Инициализация приложения
  init() {
    return new Promise((resolve, reject) => {
      LifeBridge.send('LifeMiniAppInit', {})
        .then((msg) => {
          console.log(msg)
          resolve(msg)
        })
        .catch((err) => {
          reject(err)
        })
    }).catch((err) => {
      console.log('Miniapp LifeMiniAppInit ERROR: ', err)
    })
  }

  // Получение кода авторизации
  getAuthCode() {
    return new Promise((resolve, reject) => {
      LifeBridge.send('LifeMiniAppAuthCode', {})
        .then((response) => {
          resolve(response)
        })
        .catch((err) => {
          reject(err)
        })
    })
  }

  goToLink(link) {
    return new Promise((resolve, reject) => {
      LifeBridge.send('LifeMiniAppOpenUrl', {
        url: link,
        use_external_browser: false,
        show_open_in_browser_button: false,
      })
        .then((response) => {
          resolve(response)
        })
        .catch((err) => {
          reject(err)
        })
    })
  }
}
